<template>
  <div
    class="tc-attribution-card"
    :class="embedded ? 'tc-row-detail-embedded' : ''"
    :style="embedded ? '' : 'max-width:600px;margin:0 auto;box-shadow:var(--shadow-16)'"
  >
    <div class="tc-attribution-header" style="position:relative">
      <div class="tc-attribution-event-meta">
        <span class="tc-event-source-badge tc-event-source-outlook">O</span>
        <span>Mon Apr 16 – Tue Apr 17</span>
        <span>·</span>
        <span class="fw-semibold tc-attribution-duration">3.0h this period</span>
      </div>
      <h2 class="tc-attribution-event-title">2024-ACME-001 · Support</h2>
      <div class="tc-attribution-event-meta" style="margin-bottom:0">Acme Corp</div>
      <button
        v-if="closeable"
        type="button"
        class="tc-btn-icon"
        style="position:absolute;top:var(--s-12);right:var(--s-12)"
        aria-label="Close"
        @click="emit('close')"
      >
        <svg viewBox="0 0 18 18" fill="none" aria-hidden="true">
          <path d="M13.5 4.5L4.5 13.5M4.5 4.5l9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      </button>
    </div>

    <div class="tc-attribution-body tc-scroll">
      <div class="tc-attribution-field" style="margin-bottom:0">
        <div class="d-flex align-items-center gap-2 mb-2">
          <span class="tc-attribution-label" style="margin-bottom:0">Note</span>
          <span style="font-size:10px;font-variant:small-caps;color:var(--fg-tertiary);letter-spacing:0.04em">generated</span>
          <div style="flex:1"></div>
          <button type="button" class="btn btn-outline-secondary btn-sm">Edit</button>
          <button type="button" class="btn btn-outline-secondary btn-sm">Regenerate</button>
        </div>
        <textarea
          class="form-control"
          rows="3"
          readonly
        >Reviewed Acme SSO ticket and joined sync with stakeholders</textarea>
      </div>
    </div>

    <div
      class="d-flex align-items-center gap-2 px-3 py-2"
      style="border-top:1px solid var(--stroke-1);cursor:pointer;user-select:none"
      role="button"
      tabindex="0"
      :aria-expanded="eventsOpen"
      @click="eventsOpen = !eventsOpen"
      @keydown.enter="eventsOpen = !eventsOpen"
      @keydown.space.prevent="eventsOpen = !eventsOpen"
    >
      <span style="font-size:11px;color:var(--fg-tertiary)">{{ eventsOpen ? '▴' : '▾' }}</span>
      <span style="font-size:var(--t-13);color:var(--fg-secondary)">
        Summarised from {{ CONTRIBUTING_EVENTS.length }} events
      </span>
    </div>

    <div v-if="eventsOpen">
      <ul class="tc-events-list" style="padding:var(--s-8) var(--s-12);gap:var(--s-4)">
        <li
          v-for="ev in CONTRIBUTING_EVENTS"
          :key="ev.id"
          class="tc-event-card"
          style="cursor:default"
        >
          <div class="conf-bar"></div>
          <div class="tc-event-card-meta">
            <span
              v-if="ev.source === 'Freshdesk'"
              class="tc-event-source-badge tc-event-source-freshdesk"
              title="Freshdesk"
            >F</span>
            <span
              v-else
              class="tc-event-source-badge tc-event-source-outlook"
              title="Outlook"
            >O</span>
            <span class="tc-event-card-time">{{ ev.when }}</span>
            <span class="ms-auto tc-event-card-time">{{ ev.hours }}h</span>
          </div>
          <div class="tc-event-card-title">{{ ev.title }}</div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

interface ContributingEvent {
  id: string;
  when: string;
  title: string;
  source?: string;
  hours: number;
}

defineProps<{
  closeable?: boolean;
  embedded?: boolean;
}>();

const emit = defineEmits<{
  close: [];
}>();

const eventsOpen = ref(false);

const CONTRIBUTING_EVENTS: ContributingEvent[] = [
  { id: 'ce-1', when: 'Mon 16 · 09:00', title: 'Acme weekly sync', hours: 1.0 },
  { id: 'ce-2', when: 'Tue 17 · 09:00', title: 'Acme weekly sync', hours: 0.5 },
  { id: 'ce-3', when: 'Tue 17 · 09:35', title: 'Acme SSO ticket', source: 'Freshdesk', hours: 1.0 },
  { id: 'ce-4', when: 'Thu 19 · 10:00', title: 'Acme follow-up', hours: 0.5 },
];
</script>
